module.exports = __webpack_public_path__ + "static/media/QuietStandMale.244afa6e.svg";